import { Badge } from "@soft-db/ui";
import { useTryUser } from "../../api/user-query";
import AppChipAvatar from "../common/AppChipAvatar.vue";

export default defineComponent({
	name: "UserBadge",
	props: {
		id: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const { user } = useTryUser(computed(() => props.id));

		const { t } = useI18n();

		return () =>
			user.value ? (
				<AppChipAvatar text={user.value.name} avatar={user.value.avatarUrl} sm />
			) : (
				<Badge size="sm" color="secondary">
					{t("role.sys_admin")}
				</Badge>
			);
	},
});
